import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useProductPresentations() {
  const { token } = useContext(AuthContext);
  const [presentations, setPresentations] = useState([]);

  useEffect(() => {
    if (!token) return;

    const load = async () => {
      try {
        const res = await fetchWithInterceptor(
          "/api/presentations?isActive=true&limit=1000",
          {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          }
        );
        if (res?.ok) {
          const data = await res.json();
          const rows = data.rows || [];
          setPresentations(rows);
        }
      } catch (err) {
        console.error("Error loading presentations:", err);
      }
    };

    load();
  }, [token]);

  return { presentations };
}
